'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import graphicBanner from 'assets/images/graphic-banner.webp';
import MographicBanner from 'assets/images/mo-graphic-banner.jpg';
export default function HeroBanner() {
  const $ = _c(10);
  const showImage = process.env.NEXT_PUBLIC_SHOW_IMAGE === "true";
  const [isPlaying, setIsPlaying] = React.useState(true);
  const iframeRef = React.useRef(null);
  let t0;
  if ($[0] !== isPlaying) {
    t0 = () => {
      if (!iframeRef.current) {
        return;
      }
      const vimeoIframe = iframeRef.current;
      const action = isPlaying ? "pause" : "play";
      vimeoIframe.contentWindow.postMessage({
        method: action
      }, "*");
      setIsPlaying(!isPlaying);
    };
    $[0] = isPlaying;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handlePlayPause = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 bg-[linear-gradient(234deg,rgba(0,0,0,0)_64.41%,rgba(0,0,0,0.4)_91.85%)] w-full h-full lg:rounded-b-[16px] rounded-b-[14px] pointer-events-none" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handlePlayPause || $[4] !== isPlaying) {
    t2 = !showImage && <><div className="absolute inset-0 w-full h-full overflow-hidden"><iframe ref={iframeRef} className="home-hero-video home-hero-video-desktop absolute w-full h-full min-w-[1600px] md:min-w-[2400px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 lg:w-[120vw] xl:h-[120dvh] xl:min-w-[100%] xl:top-[50%] xl:left-[50%] xl:-translate-x-1/2 xl:-translate-y-1/2" id="vimeo-video-desktop" src="https://player.vimeo.com/video/938308865?fl=pl&fe=vl&badge=0&background=1" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="home-hero-video-background" allowFullScreen={true} style={{
          objectFit: "cover",
          pointerEvents: "auto",
          border: 0
        }} /></div><div className="absolute right-5 bottom-5 z-20 flex gap-3"><button onClick={handlePlayPause} className="cursor-pointer border-3 opacity-70 hover:opacity-100 border-white text-white rounded-full flex items-center justify-center shadow-lg lg:w-12 lg:h-12 w-9 h-9 transition-opacity duration-300 ease-in-out" aria-label={isPlaying ? "Pause video" : "Play video"}>{isPlaying ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="lg:w-6 lg:h-6 w-5 h-5"><rect x="6" y="5" width="4" height="14" rx="2" fill="white" /><rect x="14" y="5" width="4" height="14" rx="2" fill="white" /></svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="lg:w-6 lg:h-6 w-5 h-5"><polygon points="6,4 20,12 6,20" fill="white" /></svg>}</button></div></>;
    $[3] = handlePlayPause;
    $[4] = isPlaying;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = showImage && <><Image src={graphicBanner} alt="Parade of Hearts - Celebrating art, culture, and connection in the Kansas City region" fill={true} sizes="100vw" className="object-cover sm:block hidden" priority={true} /><Image src={MographicBanner} alt="Parade of Hearts - Celebrating art, culture, and connection in the Kansas City region" priority={true} className="object-cover object-top sm:hidden block h-[calc(100dvh-52px)]" sizes="(max-width: 640px) 100vw" /></>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute container-wrap xl:bottom-15 bottom-10 left-0 right-0 z-10"><Link href="#artistCall" className="flex lg:gap-2 gap-1 flex-col w-fit items-center lg:mx-0 mx-auto"><span className="block lg:w-[4px] w-[3px] h-[62px] rounded-[20px]" style={{
          background: "linear-gradient(180deg, #73C429 0%, #00EAFD 100%)",
          boxShadow: "0px 4px 4.7px 0px rgba(0, 0, 0, 0.25)"
        }} /><span className="text-white font-semibold lg:text-base text-sm leading-[1.25em] !bg-transparent">Scroll</span></Link></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2) {
    t5 = <div className="relative w-full"><div className="relative w-full h-[calc(100dvh-52px)] max-h-[calc(100dvh-52px)] bg-black lg:h-[calc(100dvh-60px)] lg:max-h-[calc(100dvh-60px)] 2xl:h-[calc(100dvh-68px)] 2xl:max-h-[calc(100dvh-68px)] lg:rounded-b-[16px] rounded-b-[14px] overflow-hidden">{t1}{t2}{t3}{t4}</div></div>;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}